import type { MetaFunction } from 'react-router'
import { Partner } from '@/pages/Partner'
import { buildMeta } from '@/seo/meta'

export const meta: MetaFunction = () =>
  buildMeta({
    title: 'Lavoriamo insieme | Spadhausen',
    description:
      'Diventa partner Spadhausen: reseller iscritto al ROC o partner complementare. Rete in fibra e radio di proprietà a Ravenna, assistenza umana e un referente dedicato per la connettività dei tuoi clienti.',
    canonical: '/lavoriamo-insieme',
  })

export default function Route() {
  return <Partner />
}
